module.exports = __webpack_public_path__ + "img/上海海洋大学.d75c70cd.png";